<template>
    <div>
        <div class="row">
            <div class="mb-3 col-12" v-if="errorMessage.length > 0">
                <div class="row">
                    <div class="card  card-text bg-error">
                        <div class="d-flex col-12 justify-content-center">
                            <i class="bi bi-exclamation-lg"></i>
                            <p class="card-text">{{ errorMessage }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3 col-12">
                <label for="telephone_user" class="form-label fw-bold">Téléphone*</label>
                <input type="text" class="form-control" @keypress.enter="save" id="telephone_user" placeholder="Téléphone"
                    v-model="formData.telephone" required>
                <small class="text-danger bg-white rounded p-1" v-if="errors['telephone']">{{ errors['telephone'][0]
                    }}</small>

            </div>
            <div class="mb-3 col-12">
                <label for="password_user" class="form-label fw-bold">Mot de passe*</label>
                <div class="input-group">
                    <input :type="pwdShow ? 'text' : 'password'" class="form-control" @keypress.enter="save" id="password_user"
                        placeholder="Mot de passe" v-model="formData.password" required>
                    <span class="input-group-text" role="button" @click="pwdShow = !pwdShow">
                        <i v-if="!pwdShow" class="bi bi-eye"></i>
                        <i v-if="pwdShow" class="bi bi-eye-slash"></i>
                    </span>
                </div>
                <small class="text-danger bg-white rounded p-1" v-if="errors['password']">{{ errors['password'][0]
                    }}</small>

            </div>

        </div>
        <div class="row">
            <div class="col text-end">
                <button class="btn btn-primary" @click="save"><i class="bi bi-lock mx-1"></i>Envoyer</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import { useUserStore } from '@/store/userStore';

export default {
    name: "LoginForm",
    mixins: [formMixin],
    data: () => ({
        pwdShow: false,
        url: 'auth/login',
        // defaultData:{
        //     telephone:'0101010102',
        //     password:'1234'
        // }
    }),
    computed: {
        userStore: () => useUserStore()
    },

    methods: {
        afterSave() {
            console.log(this.apiResponse);
            this.userStore.setUser(this.apiResponse.data)
            this.userStore.setToken(this.apiResponse.token)
            const route = this.$router.resolve({ name: "home" });

            // this.$router.push({name:"dashboard"})
            window.location.href = route.fullPath;
        }
    }
}
</script>